import React, { useState } from "react"
import { ExpenseTag as ExpenseTagModel } from "@finway-group/shared/lib/models"
import ExpenseTag from "./expenseTag"
import ExpenseTagManagerPopover from "./popovers/expenseTagManager.popover"
import ExpenseTagViewer from "./popovers/expenseTagViewer.popover"
import { useDispatch } from "react-redux"
import { detachTagExpense } from "Shared/store/actions/expense/expenseActions"
import { NotificationService } from "Shared/services"
import { useExpenseTagsByIds, useExpenseTagsInLoadingState } from "Shared/hooks/expenseTags.hooks"
import { useTranslation } from "react-i18next"

interface ExpenseTagSectionPropInterface {
    expenseId: string,
    expenseTags: string[]
}

const MAX_TAGS = 3

const ExpenseTagSection: React.FC<ExpenseTagSectionPropInterface> = ({ expenseId, expenseTags }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const attachedTags = useExpenseTagsByIds(expenseTags)
    const { expenseTagsLoading, addTagInLoading, removeTagFromLoading } = useExpenseTagsInLoadingState()

    const onDetachTagExpense = async (expenseTagId: string) => {
        try {
            addTagInLoading(expenseTagId)
            await dispatch(detachTagExpense(expenseTagId, expenseId))
        } catch (err) {
            NotificationService.showErrorNotificationBasedOnResponseError(err, t("error:expense_tag.detach.title"))
        } finally {
            removeTagFromLoading(expenseTagId)
        }
    }

    const renderExpenseTags = (expenseTags: ExpenseTagModel[]) => {
        return expenseTags.map(expenseTag => <ExpenseTag
            className="m-5 h-34" key={expenseTag._id}
            color={expenseTag.tagColor}
            onClose={() => onDetachTagExpense(expenseTag._id)}
            closable={!expenseTagsLoading.includes(expenseTag._id)}
            isLoading={expenseTagsLoading.includes(expenseTag._id)}
        >
            {expenseTag.tagName}
        </ExpenseTag>)
    }

    const renderExpenseTagsFormatted = attachedTags.length > MAX_TAGS ? <>
        {renderExpenseTags(attachedTags.slice(0, MAX_TAGS - 1))}
        <ExpenseTagViewer expenseTags={attachedTags.slice(MAX_TAGS - 1)} onDelete={onDetachTagExpense} >
            <ExpenseTag className="m-5 h-34" color={attachedTags[MAX_TAGS - 1].tagColor}>+ {attachedTags.slice(MAX_TAGS - 1).length}</ExpenseTag>
        </ExpenseTagViewer>
    </> : renderExpenseTags(attachedTags)

    return <>
        {renderExpenseTagsFormatted}
        <ExpenseTagManagerPopover expenseId={expenseId} existingTags={attachedTags} />
    </>
}

export default ExpenseTagSection
